import { DateTime as DateTime$1 } from "../../../components/DateTime/index.js";
import { aggregateStatusSummaries, compactStatusSummaryVariant } from "../activity-evals/instance/status.js";
import { ActivityEvalStatusSummaryBadge } from "../activity-evals/instance/ActivityEvalStatusSummaryBadge.js";
import { useActivityEvals } from "../hooks/useActivityEvals.js";
import { useActiveServicePeriodInstances } from "../hooks/useActiveServicePeriodInstances.js";
import "react";
import { Icon } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
import { RiCalendarScheduleFill } from "react-icons/ri";
//#region src/modules/ServicePeriods/location-panel/LocationActiveServicePeriods.tsx
function LocationActiveServicePeriods({ applied, locationId }) {
	const rows = useActiveServicePeriodInstances({
		fire: applied > 0,
		locationId
	}).data?.servicePeriodInstances ?? [];
	const evals = useActivityEvals({
		locationId,
		sourceRefIds: rows.map((instance) => instance.id)
	});
	if (!rows.length) return null;
	return /* @__PURE__ */ jsx("div", {
		className: "flex flex-col gap-base",
		children: rows.map((instance) => {
			const statusSummary = aggregateStatusSummaries((evals.bySourceRefId[instance.id] ?? []).map((item) => item.statusSummary));
			const variant = statusSummary && statusSummary.total > 0 ? compactStatusSummaryVariant(statusSummary) : "positive";
			return /* @__PURE__ */ jsxs("div", {
				className: "gap-x-xs flex items-start",
				children: [/* @__PURE__ */ jsx(Icon, {
					className: variant === "critical" || variant === "caution" ? "mt-xxs shrink-0 animate-pulse" : "mt-xxs shrink-0",
					color: variant,
					Icon: RiCalendarScheduleFill,
					size: "sm"
				}), /* @__PURE__ */ jsxs("div", {
					className: "min-w-0",
					children: [
						/* @__PURE__ */ jsx("div", {
							className: "text-color-subtle text-xs font-medium",
							children: "Service Period"
						}),
						/* @__PURE__ */ jsxs("div", {
							className: "gap-xxs flex flex-wrap items-center",
							children: [/* @__PURE__ */ jsx("span", {
								className: "text-color-strong font-medium",
								children: instance.name
							}), /* @__PURE__ */ jsx(ActivityEvalStatusSummaryBadge, { statusSummary })]
						}),
						/* @__PURE__ */ jsxs("div", {
							className: "text-color-subtle text-xs",
							children: [
								"Ends",
								" ",
								/* @__PURE__ */ jsx(DateTime$1, {
									relative: true,
									timestamp: instance.endsAt,
									toggleRelativeOnClick: false
								})
							]
						})
					]
				})]
			}, instance.id);
		})
	});
}
//#endregion
export { LocationActiveServicePeriods };

//# sourceMappingURL=LocationActiveServicePeriods.js.map